import { useCallback, useEffect } from "react";
import { useGarageVehiclesQuery } from "@/domains/vehicleSpawn/api/useGarageVehiclesQuery";
import { useVehicleSpawnMutation } from "@/domains/vehicleSpawn/api/useVehicleSpawnMutation";
import { useShowVehicleSpawn } from "@/domains/vehicleSpawn/hooks/useShowVehicleSpawn";
import { VehicleSpawnModal } from "@/domains/vehicleSpawn/components/VehicleSpawnModal/VehicleSpawnModal";

export default function VehicleSpawnContainer() {
  const { isOpen, close, estateComplexId } = useShowVehicleSpawn();
  const { isFetching, data: vehicles = [], refetch } = useGarageVehiclesQuery({ estateComplexId });
  const vehicleSpawnMutation = useVehicleSpawnMutation();

  useEffect(() => {
    if (isOpen) refetch();
  }, [isOpen, refetch]);

  const handleSpawnVehicle = useCallback(
    async (vehicleId: number) => {
      vehicleSpawnMutation.mutate(vehicleId, {
        onSuccess: () => {
          close();
        },
      });
    },
    [vehicleSpawnMutation, close],
  );

  return (
    <VehicleSpawnModal
      open={isOpen}
      onClose={close}
      vehicles={vehicles}
      onSpawnClick={handleSpawnVehicle}
      isLoading={isFetching}
    />
  );
}
